"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const errorHandling_1 = require("../../utils/errorHandling");
const TypesLib = require("@caddigital/sok-types");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function fetchSchema(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.FETCH_SCHEMA_REQUEST), (0, operators_1.mergeMap)(({ payload }) => {
            const params = Object.entries(payload.params)
                .map((x) => x.join('='))
                .join('&');
            return ajax({
                headers: {
                    Authorization: getToken()
                },
                method: 'GET',
                url: `${baseUrl}api/files/${payload.id}/metadata${params.length > 0 ? `?${params}` : ''}`
            }).pipe((0, operators_1.mergeMap)(({ response }) => TypesLib.Project.iProjectMetadata
                .decode(response)
                .fold((err) => (0, rxjs_1.of)(Actions.fetchSchemaFailure((0, errorHandling_1.parseValidationError)(err))), (res) => (0, rxjs_1.of)(Actions.fetchSchemaSuccess(res)))), (0, operators_1.catchError)((error) => {
                return (0, rxjs_1.of)(Actions.fetchSchemaFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)));
            }));
        }));
    }
    return { fetchSchema };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map